import { Button } from './ui.js';

export const flirtWarning =
  'Только для совершеннолетних: неграфические вопросы о близости, желаниях и личных границах. Согласие на игру не означает согласие на близость. Любой ответ можно пропустить, игру — закончить.';

export function FlirtConsent({
  onAccept,
  onDecline,
  pending = false,
}: {
  onAccept: () => void;
  onDecline: () => void;
  pending?: boolean;
}) {
  return (
    <section className="game-card__confirm" aria-label="Согласие на Флирт 18+">
      <strong>Флирт 18+</strong>
      <p>{flirtWarning}</p>
      <div className="game-card__actions">
        <Button disabled={pending} onClick={onAccept}>
          Согласен, продолжить
        </Button>
        <Button tone="secondary" disabled={pending} onClick={onDecline}>
          Не сейчас
        </Button>
      </div>
    </section>
  );
}
